import React from 'react';

import { Webhook as WebhookIcon } from '@mui/icons-material';
import { Box, Chip, Stack, Typography } from '@mui/material';

import { InboundIntegrationsPageWrapper } from 'src/components/apiIntegrations';
import { PageLayout, TabItem, Tabs } from 'src/components/common';
import { pageLayoutPaperSx } from 'src/constants/styles';
import { TableDataProvider } from 'src/providers/TableDataProvider';
import { SxProp } from 'src/types/mui';

export const ApiIntegrationsPage: React.FC = () => {
  return (
    <PageLayout titleContent="API & Integrations" paperSx={pageLayoutPaperSx}>
      <Box mt={2}>
        <Tabs tabs={INTEGRATION_TABS} additionalTabsContainerStyles={{ mx: 2 }} />
      </Box>
    </PageLayout>
  );
};

const INTEGRATION_TABS_KEY = {
  inbound: 'inbound',
  outbound: 'outbound',
} as const;

const emptyStateStyles: SxProp = {
  py: 8,
};

const emptyStateIconStyles: SxProp = theme => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 56,
  height: 56,
  borderRadius: 2,
  backgroundColor: theme.palette.action.selected,
  color: theme.palette.primary.main,
});

const comingSoonChipStyles: SxProp = {
  fontWeight: 700,
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
};

const INTEGRATION_TABS: TabItem[] = [
  {
    key: INTEGRATION_TABS_KEY.inbound,
    label: 'Inbound',
    component: (
      <TableDataProvider>
        <InboundIntegrationsPageWrapper />
      </TableDataProvider>
    ),
  },
  {
    key: INTEGRATION_TABS_KEY.outbound,
    label: 'Outbound',
    component: (
      <Stack alignItems="center" spacing={2} sx={emptyStateStyles}>
        <Box sx={emptyStateIconStyles}>
          <WebhookIcon />
        </Box>
        <Typography variant="h6" fontWeight={700}>
          Outbound integrations
        </Typography>
        <Typography variant="body2" color="text.secondary" textAlign="center" maxWidth={420}>
          Push verification events to partner systems via webhooks and scheduled deliveries.
        </Typography>
        <Chip label="Coming Soon" size="small" sx={comingSoonChipStyles} />
      </Stack>
    ),
  },
];
